

















































import { Component, Vue, Prop, PropSync, Watch } from 'vue-property-decorator';
import { DxDropDownBox } from 'devextreme-vue/drop-down-box';
import DxScrollView from 'devextreme-vue/scroll-view';
import { DxCheckBox } from 'devextreme-vue/check-box';

interface Item {
  id: number;
  name: string;
  check?: boolean;
}

@Component({
  name: 'FlatDropDownBox',
  components: {
    DxDropDownBox,
    DxScrollView,
    DxCheckBox
  }
})
export default class extends Vue {
  @Prop({ required: true }) items!: Item[];
  @PropSync('inputData', { default: () => [] }) selectedIds!: number[];
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: '' }) title!: string;
  @Prop({ default: 'Выберите элементы' }) placeholder!: string;
  @Prop({ default: true }) enableSelectAllCheckbox!: boolean;

  internalItems: Item[] = [];
  selectAllCheckbox = false;

  mounted() {
    this.syncInternalItems();
  }

  @Watch('items', { deep: true })
  @Watch('selectedIds', { deep: true })
  syncInternalItems() {
  const seen = new Set<number>();
  this.internalItems = this.items
    .filter(item => {
      if (seen.has(item.id)) return false;
      seen.add(item.id);
      return true;
    })
    .map(item => ({
      ...item,
      check: this.selectedIds.includes(item.id)
    }));

  this.selectAllCheckbox = this.internalItems.every(i => i.check);
}

  onDropDownValueChanged(e: any) {
    if (e.value === null) {
      this.clearAllSelections();
    }
  }

  onAllSelectionChanged(e: any) {
    const value = e.value;
    this.internalItems.forEach(i => (i.check = value));
    this.emitSelection(value ? this.internalItems.map(i => i.id) : []);
  }

  onItemCheckChanged(item: Item, e: any) {
    item.check = e.value;
    const selected = this.internalItems.filter(i => i.check).map(i => i.id);
    this.selectAllCheckbox = selected.length === this.internalItems.length;
    this.emitSelection(selected);
  }

  clearAllSelections() {
    this.internalItems.forEach(i => (i.check = false));
    this.selectAllCheckbox = false;
    this.emitSelection([]);
  }

  emitSelection(ids: number[]) {
    this.selectedIds = ids;
  }

  get displayValue(): string[] {
    const checked = this.internalItems.filter(i => i.check);
    if (!checked.length) return [];
    if (checked.length === this.internalItems.length) return ['Все'];
    return checked.map(i => i.name);
  }
}
